import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HostService } from '@vendasta/billing';
import { Observable } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { handleFileUploadError } from '../http-shared/error-handlers';
import { FileData } from './file';
import { FilePurpose } from './purpose';

@Injectable({ providedIn: 'root' })
export class StripeFileService {
  constructor(private hostService: HostService, private httpClient: HttpClient) {}

  uploadFile(merchantId: string, purpose: FilePurpose, file: Blob): Observable<FileData> {
    const formData = new FormData();
    formData.append('merchant_id', merchantId);
    formData.append('purpose', purpose);
    formData.append('file', file);

    return this.httpClient
      .post<FileData>(`${this.hostService.hostWithScheme}/stripe/files`, formData, this.apiOptions())
      .pipe(share(), catchError(handleFileUploadError));
  }

  private apiOptions(): { withCredentials: boolean } {
    return {
      withCredentials: true,
    };
  }
}
